export default __webpack_public_path__ + "static/media/swoop.9deb2ad3.svg";